
"use client"

import { useState } from "react"
import { ChevronDownMini } from "@medusajs/icons"
import clsx from "clsx"
import FilterRadioGroup from "@modules/common/components/filter-radio-group"

export type SortOptions = "price_asc" | "price_desc" | "created_at"

type SortProductsProps = {
  sortBy: SortOptions
  setQueryParams: (name: string, value: string) => void
  "data-testid"?: string
}

const sortOptions = [
  {
    value: "created_at",
    label: "Últimas novedades",
  },
  {
    value: "price_asc",
    label: "Precio: de menor a mayor",
  },
  {
    value: "price_desc",
    label: "Precio: de mayor a menor",
  },
]

const SortProducts = ({
  "data-testid": dataTestId,
  sortBy,
  setQueryParams,
}: SortProductsProps) => {
  const [open, setOpen] = useState(false)

  const handleChange = (value: string) => {
    setQueryParams("sortBy", value as SortOptions)
    setOpen(false)
  }

  const selectedLabel =
    sortOptions.find((option) => option.value === sortBy)?.label ||
    "Últimas novedades"

  return (
    <>
      {/* Móvil: botón horizontal desplegable */}
      <div className="relative z-40 w-full small:hidden">
        <button
          type="button"
          onClick={() => setOpen((previous) => !previous)}
          aria-expanded={open}
          className={clsx(
            "flex min-h-10 items-center justify-center gap-2 rounded-full border border-ui-border-base bg-white px-3 py-2 text-small-regular",
            open && "border-ui-fg-base"
          )}
        >
          <span>Ordenar</span>
          <ChevronDownMini
            className={clsx(
              "h-4 w-4 transition-transform",
              open && "rotate-180"
            )}
          />
        </button>

        {open && (
          <>
            <button
              type="button"
              aria-label="Cerrar opciones de ordenamiento"
              className="fixed inset-0 z-40 cursor-default bg-transparent"
              onClick={() => setOpen(false)}
            />

            <div className="absolute left-0 top-full z-50 mt-2 min-w-[230px] rounded-lg border border-ui-border-base bg-white p-4 shadow-lg">
              <p className="mb-3 text-small-regular font-semibold">
                Ordenar por
              </p>

              <div className="flex flex-col gap-3">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    type="button"
                    onClick={() => handleChange(option.value)}
                    className={clsx(
                      "w-full text-left text-small-regular",
                      sortBy === option.value
                        ? "font-semibold text-ui-fg-base"
                        : "text-ui-fg-subtle"
                    )}
                  >
                    {option.label}
                    {sortBy === option.value ? " ✓" : ""}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Computador: conservar el selector existente */}
      <div className="hidden small:block">
        <FilterRadioGroup
          title="Ordenar por"
          items={sortOptions}
          value={sortBy}
          handleChange={handleChange}
          data-testid={dataTestId}
        />
      </div>
    </>
  )
}

export default SortProducts
